export default {
  data: function() {
    return {
      holdChangesModel: null,
      holdChangesParentModel: null,
      shouldValidate: false
    };
  },
  mounted() {
    this.checkHoldChangesMixinInitialization();
  },
  computed: {
    isComplete(): boolean {
      throw new Error("isComplete function is not set up.");
    }
  },
  methods: {
    cancel(event): void {
      this.holdChangesModel.resetChanges();
      if (!this.holdChangesModel.isAttached) {
        this.holdChangesModel.triggerChanges = true;
      }
      this.$emit('cancel')
      if (typeof this.emitHideModal === 'function') {
        this.emitHideModal(event);
      }
    },
    save(event): void {
      if (!this.isComplete) {
        this.shouldValidate = true;
        return;
      }
      if (!this.holdChangesModel.isAttached) {
        this.holdChangesModel.attachToParent(this.holdChangesParentModel);
      }
      this.holdChangesModel.triggerChanges = true;
      this.emitHideModal(event);
    },
    checkHoldChangesMixinInitialization() {
      if (!this.holdChangesModel) {
        throw new Error("You have not assigned the model where changes need to be held.");
      }
      if (!this.holdChangesParentModel) {
        throw new Error("You have not assigned the parent model where changes need to be held.");
      }
    }
  }
};
